import { render } from "./asset-last-alarms.vue?vue&type=template&id=3a371034&scoped=true"
import script from "./asset-last-alarms.vue?vue&type=script&lang=js"
export * from "./asset-last-alarms.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3a371034"

export default script